/** Legacy installs may still open /get-started. Neither route is a user visit. */
export function isExtensionSessionRoute(pathname: string): boolean {
  return pathname === '/extension-session' || pathname === '/get-started';
}
